import { AppError } from './app-error'

export class ServiceUnavailableError extends AppError {
  private static NAME: string = 'ServiceUnavailableError'
  public static MESSAGE: string = `Estamos realizando uma manutenção em nossos serviços.
  
  Em breve, tudo estará de volta ao normal.`

  constructor(message?: string | null) {
    super(ServiceUnavailableError.NAME, message ?? ServiceUnavailableError.MESSAGE)
  }
}
